import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withShowHide } from '@sparefoot/react-core/decorators';
import CSSTransition from 'react-transition-group/CSSTransition';

import './Notification.scss';

export const enhance = withShowHide('notification', true);

export function Notification({
	children,
	notificationShowing,
	onHideNotification,
	permanent = false,
}) {
	useEffect(() => {
		const timer = setTimeout(onHideNotification, 10000);
		return () => clearTimeout(timer);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	return (
		<CSSTransition
			classNames="transition-fade-in"
			in={notificationShowing}
			unmountOnExit={!permanent}
			timeout={permanent ? null : 150}
		>
			<div className="ss-notification">{children}</div>
		</CSSTransition>
	);
}

Notification.propTypes = {
	children: PropTypes.node,
	notificationShowing: PropTypes.bool,
	onHideNotification: PropTypes.func,
	permanent: PropTypes.bool,
};

export default enhance(Notification);
